import { useFormContext } from '@calendly/form'
import { useMemo } from 'react'

import { useETEditorFormikPoolingType } from 'services/event_types'

import { filterByPoolingType, getUserPoolUid, withoutDeleted } from '../helpers'

export const useUserPoolsData = () => {
  const { values: { userPools = [] } } = useFormContext()

  const { isCollective, isRoundRobin, isCollectiveRoundRobin } = useETEditorFormikPoolingType()

  const currentUserPools = useMemo(() => withoutDeleted(userPools), [userPools])
  const currentUserPoolsCount = useMemo(() => currentUserPools.length, [currentUserPools])
  const isLastUserPool = isCollective || isRoundRobin || currentUserPoolsCount === 1

  const collectiveUserPools = useMemo(() => filterByPoolingType(currentUserPools, 'collective'), [currentUserPools])
  const roundRobinUserPools = useMemo(() => filterByPoolingType(currentUserPools, 'round_robin'), [currentUserPools])
  const collectiveUserPoolsCount = useMemo(() => collectiveUserPools.length, [collectiveUserPools])
  const roundRobinUserPoolsCount = useMemo(() => roundRobinUserPools.length, [roundRobinUserPools])
  const hasCollectiveUserPools = isCollective || collectiveUserPoolsCount > 0
  const hasRoundRobinUserPools = isRoundRobin || roundRobinUserPoolsCount > 0
  const hasOnlyRoundRobinUserPool = isRoundRobin || (isCollectiveRoundRobin && userPools.length === 1 && roundRobinUserPools.length)

  const collectiveUserPool = collectiveUserPools[0]
  const collectiveUserPoolUid = getUserPoolUid(collectiveUserPool)

  return {
    userPools,

    currentUserPools,
    currentUserPoolsCount,
    isLastUserPool,

    collectiveUserPool,
    collectiveUserPoolUid,

    isRoundRobin,

    collectiveUserPools,
    roundRobinUserPools,
    collectiveUserPoolsCount,
    roundRobinUserPoolsCount,
    hasCollectiveUserPools,
    hasRoundRobinUserPools,
    hasOnlyRoundRobinUserPool,
  }
}
